import type { FleetGroup } from '#domain/FleetGroup.ts';
import type { Tour, TourStatus } from '#domain/Tour.ts';
import { getTourVehicle, getVehicleFleetGroupName } from '#domain/tourVehicle.ts';
import type { Vehicle } from '#domain/Vehicle.ts';

const TourStatusWeight: Record<NonNullable<TourStatus>, number> = {
    problem: 1,
    'in-transit': 2,
    planned: 3,
    open: 4,
    finished: 5,
};

export const mapTourStatusToOrderStatusWeight = (status: TourStatus | undefined): number => {
    return status ? TourStatusWeight[status] : 5;
};

export type TourWithSortableKey = Tour & {
    statusWeight: number;
    firstStopEndTarget?: string;
    lastStopEndTarget?: string;
    progressPercentage?: number;
    licensePlate?: string;
    fleetGroupName?: string;
};

// We need to add new keys only used for sorting the items (its not supported to do sorting on nested objects)
export const addSortableTourKey = (
    items: Tour[],
    vehicles: Vehicle[],
    fleetGroups: FleetGroup[] = []
): TourWithSortableKey[] =>
    items.map(tour => ({
        ...tour,
        firstStopEndTarget: tour.firstStop?.endTarget,
        lastStopEndTarget: tour.lastStop?.endTarget,
        progressPercentage:
            tour.progress.totalStopAmount > 0
                ? (tour.progress.finishedStopAmount / tour.progress.totalStopAmount) * 100
                : 0,
        licensePlate: getTourVehicle(tour, vehicles)?.plate,
        fleetGroupName: getVehicleFleetGroupName(getTourVehicle(tour, vehicles), fleetGroups),
        statusWeight: mapTourStatusToOrderStatusWeight(tour.status),
    }));
